function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useMemo, useContext, useState, useLayoutEffect, useEffect, createContext, createElement, forwardRef } from 'react';
var StoreContext = /*#__PURE__*/createContext();
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

var customContext = function customContext(context) {
  return function () {
    for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
      keys[_key] = arguments[_key];
    }

    var store = useContext(context);

    if (process.env.NODE_ENV !== 'production' && !store) {
      throw new Error('Could not find storeon context value.' + 'Please ensure the component is wrapped in a <StoreContext.Provider>');
    }

    var rerender = useState({});
    useIsomorphicLayoutEffect(function () {
      return store.on('@changed', function (_, changed) {
        var changesInKeys = keys.some(function (key) {
          return key in changed;
        });
        if (changesInKeys) rerender[1]({});
      });
    }, []);
    return useMemo(function () {
      var state = store.get();
      var data = {};
      keys.forEach(function (key) {
        data[key] = state[key];
      });
      data.dispatch = store.dispatch;
      return data;
    }, [rerender[0]]);
  };
};

var useStoreon = customContext(StoreContext);

var connectStoreon = function connectStoreon() {
  for (var _len2 = arguments.length, keys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    keys[_key2] = arguments[_key2];
  }

  var Component = keys.pop();
  return /*#__PURE__*/forwardRef(function (originProps, ref) {
    var props = _objectSpread(_objectSpread(_objectSpread({}, originProps), useStoreon.apply(void 0, keys)), {}, {
      ref: ref
    });

    return /*#__PURE__*/createElement(Component, props);
  });
};

export { useStoreon, StoreContext, connectStoreon, customContext };